import Enumerator from './Enumerator';

export const creditCardTypes = ['none', 'visa', 'mastercard', 'amex', 'store_card', 'other'];

export class CreditCardType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'mastercard';
        break;
      case '2':
        correctOption = 'visa';
        break;
      case '3':
        correctOption = 'amex';
        break;
      case '4':
        correctOption = 'store_card';
        break;
      case '5':
        correctOption = 'other';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

CreditCardType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  visa: {
    get title() {
      return 'Visa';
    }
  },
  mastercard: {
    get title() {
      return 'Mastercard';
    }
  },
  amex: {
    get title() {
      return 'AMEX';
    }
  },
  store_card: {
    get title() {
      return 'Store card';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  creditCardTypes,
  CreditCardType
};
